var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8002 25.8002V16.4242C25.8002 11.8162 24.8082 8.2962 19.4322 8.2962C16.8402 8.2962 15.1122 9.7042 14.4082 11.0482H14.3442V8.71219H9.2562V25.8002H14.5682V17.3202C14.5682 15.0802 14.9842 12.9362 17.7362 12.9362C20.4562 12.9362 20.4882 15.4642 20.4882 17.4482V25.7682H25.8002V25.8002ZM0.616195 8.71219H5.92819V25.8002H0.616195V8.71219ZM3.2722 0.200195C1.5762 0.200195 0.200195 1.5762 0.200195 3.2722C0.200195 4.9682 1.5762 6.37619 3.2722 6.37619C4.9682 6.37619 6.3442 4.9682 6.3442 3.2722C6.3442 1.5762 4.9682 0.200195 3.2722 0.200195Z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3b302a83a9f76f20aaed61365184f959.svg";
export { ForwardRef as ReactComponent };